<template>
  <div class="form-group">
    <select :value="value" @change="onChange" class="form-control" :name="name" v-validate="validation">
      <option v-for="option in options" :value="option['.key']" :selected="value == option['.key']">
        {{option.name}}
      </option>
    </select>
  </div>
</template>

<script>
export default {
  props: {
    label: String,
    value: [Number,String],
    placeholder: String,
    disabled: String,
    options: Array,
    
    name: String,
    styler: {
      default:''
    },
    validation:{
      default: ''
    }
  },
  methods: {
    onChange (event) {
      this.$emit('input', event.target.value)
    }
  }
}
</script>


// WEBPACK FOOTER //
// FormSelect.vue?33726159